var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newUser)?_c('div',[_c('EntryPage')],1):(_vm.admin && !_vm.contestantId)?_c('div',[_c('QuizMasterPage')],1):_c('div',[_c('PlayerPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }